import { render, staticRenderFns } from "./ComponentLogin.vue?vue&type=template&id=6d85f6f4&scoped=true&lang=html"
import script from "./ComponentLogin.vue?vue&type=script&lang=js"
export * from "./ComponentLogin.vue?vue&type=script&lang=js"
import style0 from "./ComponentLogin.vue?vue&type=style&index=0&id=6d85f6f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d85f6f4",
  null
  
)

export default component.exports